import { render, staticRenderFns } from "./DailyStoreBudget.vue?vue&type=template&id=2c15680c&scoped=true&"
import script from "./DailyStoreBudget.vue?vue&type=script&lang=ts&"
export * from "./DailyStoreBudget.vue?vue&type=script&lang=ts&"
import style0 from "./DailyStoreBudget.vue?vue&type=style&index=0&id=2c15680c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15680c",
  null
  
)

export default component.exports